import { fleetManagementApi } from "../api";

export const getPayments = (params) => {
  return fleetManagementApi.get("/payments", { params });
}

export const createPayment = (data) => {
  return fleetManagementApi.post("/payments", data);
}

export const updatePayment = (paymentId, data) => {
  return fleetManagementApi.put(`/payments/${paymentId}`, data);
}

export const deletePayment = (paymentId) => {
  return fleetManagementApi.delete(`/payments/${paymentId}`);
}